import { SuretyAccountId, type SuretyQuoteId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useRequest } from "../../../utils/request";
import { bondRequestsQueryKey } from "../bond-request.keys";
import { BondRequest } from "./types";

export const useFetchBondRequestOutcome = (accountId: SuretyAccountId, id: SuretyQuoteId) => {
	const { get } = useRequest();

	const { data } = useQuery({
		queryKey: bondRequestsQueryKey(id),
		queryFn: async () => await get<BondRequest>(`/v2/surety/accounts/${accountId}/quotes/${id}`),
		retry: false,
	});

	const bondRequest = useMemo(
		() => (data ? { underwritingStatus: data.underwritingStatus } : undefined),
		[data],
	);

	return { bondRequest };
};
